import {getMsgDetail} from "../../../api/server/message"
import commonMixin from "../../../mixin/common"
import Nomsg from "../../../components/Nomsg"
export default {
  name: 'IndexPage',
  mixins: [commonMixin],
  data () {
    return {
      id: null,
      info: null
    }
  },
  components: {
    nomsg: Nomsg
  },
  computed: {
  },
  methods: {
    _getDetail () {
      let id = this.id
      if (id) {
        let query = {
          id: id
        }
        getMsgDetail(query).then((res) => {
          console.log('res', res)
          if (res.code === 200 && res.data) {
            this.info = res.data
          } else {
            this.id = null
            this.info = null
          }
        })
      }
    },
    reset () {
      this._getDetail()
    },
    handleRoute (route) {
      if (route.name === 'message-detail') {
        let id = this.$route.query.id
        this.id = id
        this.reset()
      }
    }
  },
  watch: {
    'route' (to, from) {
      this.handleRoute(to)
    }
  },
  mounted: function () {
    this.handleRoute(this.$route)
  }
}